var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34297 8.43L6.21297 7.22C6.67297 7.07333 6.99964 6.88667 7.19297 6.66C7.39297 6.42667 7.49297 6.09 7.49297 5.65C7.49297 5.31 7.4063 5.05667 7.23297 4.89C7.05964 4.72333 6.77297 4.64 6.37297 4.64C6.17297 4.64 5.97964 4.66333 5.79297 4.71C5.6063 4.75 5.43964 4.80333 5.29297 4.87L5.05297 4.3C5.27297 4.18 5.53964 4.08 5.85297 4C6.17297 3.91333 6.5063 3.87 6.85297 3.87C7.55964 3.87 8.06964 4.00667 8.38297 4.28C8.70297 4.55333 8.86297 4.96 8.86297 5.5C8.86297 6.04667 8.70964 6.47333 8.40297 6.78C8.10297 7.08667 7.66297 7.32333 7.08297 7.49V8.43H6.34297ZM6.73297 10.63C6.5063 10.63 6.31964 10.56 6.17297 10.42C6.03297 10.2733 5.96297 10.0867 5.96297 9.86C5.96297 9.63333 6.03297 9.44667 6.17297 9.3C6.31964 9.15333 6.5063 9.08 6.73297 9.08C6.95964 9.08 7.1463 9.15333 7.29297 9.3C7.4463 9.44667 7.52297 9.63333 7.52297 9.86C7.52297 10.0867 7.44964 10.2733 7.30297 10.42C7.1563 10.56 6.9663 10.63 6.73297 10.63Z",
    fill: "#C62828"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "#C62828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.01e2ea0e64061700ff2e1577a767aed4.svg";
export { ForwardRef as ReactComponent };